"use client";

import { ReactNode, createContext } from "react";

export const Context = createContext<ContextType | null>(null);

export const Provider: React.FC<ProviderProps> = ({
  navLinkComponent,
  children,
}) => (
  <Context.Provider value={{ navLinkComponent }}>{children}</Context.Provider>
);

export type ProviderProps = {
  children?: ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  navLinkComponent?: React.ComponentType<any>;
};

export type ContextType = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  navLinkComponent?: React.ComponentType<any>;
};
